export default {
  v: 3,
  apiKey: "AIzaSyAUesL0btFXydO4uhuPTDPySFJV5aM0tcg",
  mapsURL: "https://maps.googleapis.com/maps/api",
  reCaptchaKey: "6LcCnNcZAAAAANiWV6HBaE7pIYrJkn-pEq8ueFHL"
};
